import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzImageRepoWebComponent } from '../../../ui/gzImageRepo';
import { ImageState } from '../../../ui/gzImageRepo/types';
import { GridTitleConfig } from '../../../grid/uiElements/gridViewTitle/types';
import { NetworkGridDataProvider } from '../dataProvider/NetworkGridDataProvider';
import {
  WEB_COMPONENT_GENERIC_GRID_SMART_VIEWS,
  WEB_COMPONENT_GRID_VIEW,
  WEB_COMPONENT_GZ_BUTTON,
  WEB_COMPONENT_GZ_GENERIC_OVERLAY,
  WEB_COMPONENT_GZ_MEGA_MENU,
  WEB_COMPONENT_NETWORK_TREE,
} from '../../../webcomponents.constants';
import { GridViewWebComponent } from '../../../grid/gridView';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import {
  endpointTypeRenderer,
  lastSeenRenderer,
  pendingActivityRenderer,
  nameRenderer,
  managementStatusRenderer,
  policyRenderer,
  roleRenderer,
  policyTypeRenderer,
  securityIssuesRenderer,
  policyStatusRenderer,
  tagsRenderer,
  typeRenderer,
  usersRenderer,
  companyRenderer,
  powerRenderer,
  integrationTagsRenderer,
  migrationRenderer,
  inDeletedFolderRenderer,
} from '../helpers/renderers';
import {
  InitNetworkResponse,
  NetworkColumn,
  InitNetworkData,
  NetworkGridAppExternalParams,
  GuidedTourSetterResponse,
  NETWORK_DATA_PROVIDER_ERROR,
} from '../helpers/types';
import { SMART_VIEW_MAX_INPUT_LENGTH } from '../../../xdrSearchApp/xdrSearchLive/types';
import {
  CategoriesConfig,
  SmartViewEvents,
  ValidateViewNameErrorCodeResponse,
  ValidateViewNameResponse,
} from '../../../grid/genericGridSmartViews/types';
import { SmartViewInlineActions } from '../../../grid/gridSmartViews/types';
import { NetworkTreeWebComponent } from '../../networkTree';
import { GenericGridSmartViewsWebComponent } from '../../../grid/genericGridSmartViews';
import { translateFn } from '../../../utils/translator.helper';
import _, { isEqual } from 'lodash';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { NetworkPopUpFactory, NetworkPopUpType } from '../../networkPopUps/network.pop-up.factory';
import { GzMegaMenuWebComponent } from '../../../ui/gzMegaMenu';
import { MegaMenuEvents, MegaMenuIconMap, MegaMenuSection } from '../../../ui/gzMegaMenu/types';
import { GenericGridSmartViewsHelpers } from '../../../grid/genericGridSmartViews/helpers/GenericGridSmartViewsHelpers';
import { DATA_LOAD_MORE } from '../../../grid/utils/constants';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { RemoteValidator } from '../../../ui/gzForm/validators/remote.validator';
import { dataGridStrings } from '../../../grid/utils/gridStrings';
import { LinkColor, LinkType } from '../../../ui/gzLinkComponent/types';
import { ButtonColors, ButtonTypes } from '../../../ui/gzButton/types';
import { MegaMenuHelper } from '../helpers/megaMenu/mega.menu.helper';
import { SmartViewsHelper } from '../helpers/smartViews/smart.views.helper';
import { NetworkViewGridConfig } from '../helpers/smartViews/types';
import { TreeDetails } from '../../networkTree/types';
import { TemplateState } from '../../../types/common/types';
import { GzProgressSpinnerWebComponent } from '../../../ui/gzProgressSpinner';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { queryShadowHierarchy, toggleVisibility } from '../../../utils/htmlElement.utils';
import { CarouselInfoCardData, CarouselInfoCardPointerPosition } from '../../../ui/gzCarouselInfoCard/types';
import { GuidedToursManager } from '../../../guidedTours/GuidedToursManager';
import { GuidedTourSections } from '../../../guidedTours/types';
import { GridColumnConfiguration } from '@nirvana/shared/dtos/types/shared/grid';
import { ContextMenuOverlayElement } from '../../../ui/gzContextMenuOverlay';
import { Coords } from '../../../grid/gridView/types';
import { GzMultiLevelListWebComponent } from '../../../ui/gzMultiLevelList';
import { NetworkScrollableWrapperWebComponent } from '../../networkScrollableWrapper';
import { Subscription } from 'rxjs';
import { GzNavigationButtonWebComponent } from '../gzNavigationButton';
import { GridViewStatusChipWebComponent } from 'apps/webcomponents/src/grid/uiElements/gridViewStatusChip';

enum NETWORK_VIEW_CATEGORIES_TYPES {
  SAVED = 'saved',
  SECURITY_ISSUES = 'securityIssues',
  PENDING_ACTIVITY = 'pendingActivity',
  POLICIES = 'policies',
}

export class NetworkAppContainerView extends BaseWebComponentView {
  public smartViewsComponentName = 'network-v2';
  public smartViewsStrings;
  public gridDataProvider: NetworkGridDataProvider;
  private flexibleGrowingColumn = NetworkColumn.NAME;
  private gridData: InitNetworkResponse;
  private smartViewsDependencies;
  private gridStrings;
  public buttonStrings;
  private guidedTourTargetElements: Array<HTMLElement> = [];
  private iconsTourTargetElement: HTMLElement;
  private iconsHighlightTargetElement: Array<HTMLElement>;
  private megaMenuTourTargetElement: HTMLElement;
  private filtersTourTargetElement: HTMLElement;
  private treeTourTargetElement: HTMLElement;
  private smartViewsTourTargetElement: HTMLElement;
  private smartViewsHighlightTargetElement: HTMLElement;
  private treeHighlightTargetElement: HTMLElement;
  private guidedTourHighlightElements: Array<HTMLElement | Array<HTMLElement>> = [];
  private filtersHighlightElement: HTMLElement;
  private megaMenuHighlightElement: HTMLElement;
  private gridErrorSubscription$: Subscription;

  set isRecursiveDepth(value: boolean) {
    this.dom.$grid.extraParams = {
      ...this.dom.$grid.extraParams,
      isRecursive: value,
    };
    this.dom.$grid.activeViewProps.recursive = value;

    if (this.dom.$depthToggle.checked !== value) {
      this.dom.$depthToggle.checked = value;
    }

    this.dom.$grid.handleSmartViewChanges();
  }

  set treeNodeInfo(value: TreeDetails) {
    this.dom.$grid.extraParams = {
      ...this.dom.$grid.extraParams,
      nodeId: value.targetId,
      type: value.type,
    };

    // we only keep information that we want to store in db
    // this setter is called from multiple places, some sending more info than what's required
    const details: TreeDetails = {
      targetId: value.targetId,
      path: value.path,
      parentId: value.parentId,
      type: value.type,
    };

    this.dom.$grid.activeViewProps.treeDetails = details;

    this.dom.$grid.handleSmartViewChanges();
  }

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper'); // This wraps the title + grid
    this.dom.$container = this.shadow.querySelector('#network-container'); // This wraps everything
    this.dom.$grid = this.shadow.querySelector(
      `gz-push-body-layout ${WEB_COMPONENT_GRID_VIEW}`
    ) as GridViewWebComponent<Column, NetworkColumn>;
    this.dom.$smartViews = this.shadow.querySelector(
      `gz-push-body-layout ${WEB_COMPONENT_GENERIC_GRID_SMART_VIEWS}`
    ) as GenericGridSmartViewsWebComponent;

    this.dom.$depthToggle = this.shadow.querySelector('#depth-toggle');
    this.dom.$depthToggle.innerHTML = `<span class="depth-toggle">${this.dependencies.translateFn(
      'View data recursively'
    )}</span>`;

    this.dom.$goToContainerButton = this.shadow.querySelector(`${WEB_COMPONENT_GZ_BUTTON}#go-to-container`);
    this.setGlobalActionsButtons();

    this.dom.$tree = this.shadow.querySelector(`${WEB_COMPONENT_NETWORK_TREE}`) as NetworkTreeWebComponent;
    this.dom.$treeWrapper = this.shadow.querySelector('#network-tree');

    this.dom.$feedbackFormButton = this.shadow.querySelector('#feedback-btn') as GzButtonWebComponent;
    this.dom.$feedbackFormButtonText = this.shadow.querySelector('#feedback-btn-text');
    this.dom.$feedbackFormButtonText.textContent = translateFn('Feedback');

    this.dom.$treeViewTitle = this.shadow.querySelector('.accordion-title');
    this.dom.$globalLoading = this.shadow.querySelector('#globalLoading') as GzProgressSpinnerWebComponent;
    this.dom.$sectionTitle = this.shadow.querySelector('#network-title') as GzTitleWebComponent;
    this.dom.$overlay = this.shadow.querySelector('#extra-details-context-menu') as ContextMenuOverlayElement;
    this.dom.$overlayList = this.shadow.querySelector(
      '#extra-details-context-menu  gz-multi-level-list'
    ) as GzMultiLevelListWebComponent;
    this.dom.$overlayList.hasSearch = true;
    this.dom.$overlayList.searchPlaceholder = translateFn('Search actions');
    this.dom.$overlayList.noSearchResultsString = translateFn('No action found');

    this.dom.$networkScrollableWrapper = this.shadow.querySelector(
      '#network-scrollable-wrapper'
    ) as NetworkScrollableWrapperWebComponent;
    this.dom.$navButtonTop = this.shadow.querySelector('#navButtonTop') as GzNavigationButtonWebComponent;
    this.dom.$navButtonBottom = this.shadow.querySelector('#navButtonBottom') as GzNavigationButtonWebComponent;
    this.dom.$drillDownStatusChip = this.shadow.querySelector(
      '#network-drill-down-status'
    ) as GridViewStatusChipWebComponent;
    this.configureJumpToContainer();
    this.setTranslatedStrings();
    this.buildEmptyState();
    this.gridDataProvider = new NetworkGridDataProvider();
    this.gridErrorSubscription$ = this.gridDataProvider.error$.subscribe({
      next: error => {
        this.dom.$wrapper.dispatchEvent(
          new CustomEvent(NETWORK_DATA_PROVIDER_ERROR, {
            composed: true,
            bubbles: true,
            detail: error.err,
          })
        );
      },
    });
  }

  setTranslatedStrings() {
    this.smartViewsStrings = this.stringsTranslator.getSmartViewsTranslations();
    this.dom.$treeViewTitle.innerText = this.dependencies.translateFn('Tree view');
    this.dom.$treeViewTitle.tooltipText = this.dependencies.translateFn('Tree view');
    this.gridStrings = {
      dataLoadingFailed: dataGridStrings().dataLoadingFailed,
    };
    this.dom.$sectionTitle.innerText = translateFn('Network');
    this.dom.$drillDownStatusChip.text = translateFn('You are viewing drilled-down data in explore mode [***]');
    this.dom.$drillDownStatusChip.tooltipText = translateFn('Open KB article in new tab to find out more [***]');

    this.buttonStrings = {
      reports: translateFn('Reports'),
      goTo: translateFn('Go to location'),
      delete: translateFn('Delete'),
    };

    this.dom.$navButtonTop.text = this.dependencies.translateFn('Tree view');
    this.dom.$navButtonBottom.text = this.dependencies.translateFn('Smart views');
  }

  async buildSuccessView(data: InitNetworkData) {
    this.gridData = data.config;
    await this.buildSmartViews();

    const activeView = this.dom.$smartViews.controller.getActiveView();
    const standardViewConfig = SmartViewsHelper.convertGenericConfigToGridConfig(activeView);

    this.dom.$depthToggle.checked = standardViewConfig.recursive ?? false;
    if (this.dom.$grid.controller) {
      this.dom.$grid.controller.view.dom.$gridFilters.resetCompanyFilter();
    }

    const { initialViewWithoutExternalParams, view: processedView } = this.processExternalParams(
      standardViewConfig,
      data.externalParams
    );

    this.buildGrid(processedView, initialViewWithoutExternalParams);
    this.buildEarlyAccessSection();
    this.buildTreeView(processedView.treeDetails);
    this.resetTemplateState(this.dom.$wrapper);
  }

  public setLoadingState() {
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public buildTreeView(treeDetails: TreeDetails | undefined, findParentNode: boolean = false) {
    this.dom.$tree.findParentNode = findParentNode;
    this.dom.$tree.treeDetails = treeDetails;
    this.dom.$tree.propertiesSet = true;

    if (!this.dom.$tree.started) {
      this.dom.$tree.injectDependencies(this.dependencies);
      this.dom.$tree.start().then().catch();
    }
  }

  public buildGrid(view: NetworkViewGridConfig, initialView?: NetworkViewGridConfig) {
    this.dom.$grid.dataProvider = this.gridDataProvider;
    this.dom.$grid.propertiesSet = false;
    this.dom.$grid.allColumnDetails = this.gridData.allColumns;
    this.dom.$grid.columnRenderers = {
      [NetworkColumn.NAME]: nameRenderer,
      [NetworkColumn.COMPANY]: companyRenderer,
      [NetworkColumn.ENDPOINT_TYPE]: endpointTypeRenderer,
      [NetworkColumn.LAST_SEEN]: lastSeenRenderer,
      [NetworkColumn.USERS]: usersRenderer,
      [NetworkColumn.TAGS]: tagsRenderer,
      [NetworkColumn.TYPE]: typeRenderer,
      [NetworkColumn.POLICY]: policyRenderer,
      [NetworkColumn.MANAGEMENT_STATUS]: managementStatusRenderer,
      [NetworkColumn.SECURITY_ISSUES]: securityIssuesRenderer,
      [NetworkColumn.PENDING_ACTIVITY]: pendingActivityRenderer,
      [NetworkColumn.ROLE]: roleRenderer,
      [NetworkColumn.POLICY_STATUS]: policyStatusRenderer,
      [NetworkColumn.POLICY_TYPE]: policyTypeRenderer,
      [NetworkColumn.POWER]: powerRenderer,
      [NetworkColumn.AWS_INTEGRATION_TAGS]: integrationTagsRenderer,
      [NetworkColumn.MIGRATED_TO_ANOTHER_COMPANY]: migrationRenderer,
      [NetworkColumn.IN_DELETED_FOLDER]: inDeletedFolderRenderer,
    };

    if (initialView && !isEqual(view, initialView)) {
      this.dom.$grid.defaultViewProps = _.cloneDeep(initialView);
      this.dom.$grid.titleConfig = new GridTitleConfig(view.label + '*');
      this.dom.$grid.activeViewInitialProps = _.cloneDeep(initialView);
      this.dom.$grid.smartViewDiscardButtonDisabledState = false;
      this.dom.$grid.smartViewSaveButtonDisabledState = initialView.isReadOnly;
    } else {
      this.dom.$grid.defaultViewProps = _.cloneDeep(view);
      this.dom.$grid.titleConfig = new GridTitleConfig(view.label);
      this.dom.$grid.activeViewInitialProps = _.cloneDeep(view);
      this.dom.$grid.smartViewDiscardButtonDisabledState = true;
      this.dom.$grid.smartViewSaveButtonDisabledState = true;
    }

    this.dom.$grid.activeViewProps = view; // ??
    this.dom.$grid.viewId = view.id;
    this.dom.$grid.columns = view.displayedColumns;
    this.dom.$grid.filters = view.filters;
    this.dom.$grid.isCompactViewChecked = view.compactView;
    this.dom.$grid.pageSize = view.pageSize;
    this.dom.$grid.columnConfigs = view.columnConfigs ?? [];
    this.dom.$grid.favoriteIconConfig = GenericGridSmartViewsHelpers.configureFavoriteIcon(view);
    this.dom.$grid.extraParams = {
      nodeId: view.treeDetails?.targetId || Application.Main.getUser().company.id,
      type: view.treeDetails?.type || Constants.Companies.TYPE_COMPANY,
      isRecursive: view.recursive ?? false,
    };

    this.isRecursiveDepth = this.dom.$grid.extraParams.isRecursive;

    this.dom.$grid.hasSelectableRows = true;
    this.dom.$grid.hasPagination = true;
    this.dom.$grid.enableCSVExport = false;
    this.dom.$grid.smartViewsEnabled = true;
    this.dom.$grid.predefinedFiltersKeys = this.gridData.predefinedFilterKeys;
    this.dom.$grid.defaultFlexGrowColumn = this.flexibleGrowingColumn;
    this.dom.$grid.filtersUiConfigs = this.gridData.filtersUiConfigs;
    this.dom.$grid.shouldLoadAsync = true;
    this.dom.$grid.enableRowClickEvent = false;
    this.dom.$grid.sideMenuParent = this.dom.$wrapper;
    this.dom.$grid.customStrings = {
      noSearchResultsString: translateFn('No data available'),
      dataLoadingFailed: this.gridStrings.dataLoadingFailed,
    };
    this.dom.$grid.showConfigurableArea = false;
    this.dom.$grid.hideFooter = false;
    this.dom.$grid.showGlobalActions = true;
    this.dom.$grid.hasSelectionExtraOptions = true;
    this.dom.$grid.propertiesSet = true;

    if (!this.dom.$grid.started) {
      this.dom.$grid.injectDependencies(this.dependencies);
      this.dom.$grid.start().then().catch(console.error);
    }

    this.buildGridGlobalActionsToolbar();
  }

  buildErrorView() {
    this.dom.$wrapper.innerHTML = '';
    this.buildErrorTemplate();
  }

  buildEmptyState() {
    this.dom.$emptyStateAdditionalText = this.shadow.getElementById('networkAdditionalText');
    this.dom.$emptyStateAdditionalText.innerText = translateFn(
      'Try adjusting your filters or start adding entities to the network.'
    );

    this.dom.$emptyStateLink = this.shadow.getElementById('emptyStateKbLink');
    this.dom.$emptyStateLinkText = this.shadow.getElementById('emptyStateKbLinkText');
    this.dom.$emptyStateLink.type = LinkType.UNDERLINE;
    this.dom.$emptyStateLink.color = LinkColor.PRIMARY;
    this.dom.$emptyStateLink.href = Application.Main.company.isPartner()
      ? 'https://www.bitdefender.com/business/support/en/77211-157497-install-security-agents---standard-procedure.html'
      : 'https://www.bitdefender.com/business/support/en/77209-157497-install-security-agents---standard-procedure.html';
    this.dom.$emptyStateLinkText.textContent = translateFn('Learn more.');
  }

  public async refreshGrid() {
    this.dom.$grid.controller.view.setElementClass(this.dom.$grid.controller.view.dom.$wrapper, DATA_LOAD_MORE);
    await this.dom.$grid.controller.handleGridItemsLoad(true, true);
    this.dom.$grid.controller.view.removeElementClass(this.dom.$grid.controller.view.dom.$wrapper, DATA_LOAD_MORE);
  }

  public setMegaMenuSections(sections: Array<MegaMenuSection>): void {
    this.dom.$megaMenu.sections = sections;
  }

  public toggleGlobalActionsButtons(enabled: boolean): void {
    this.dom.$globalActionsButton.disabled = !enabled;
    this.dom.$reportsButton.disabled = !enabled;
  }

  public toggleGoToContainer(enabled: boolean): void {
    this.dom.$goToContainerButton.disabled = !enabled;
  }

  public toggleDeleteEntitiesButton(enabled: boolean): void {
    this.dom.$deleteEntitiesButton.disabled = !enabled;
  }

  public toggleSpinnerDeleteEntitiesButton(showSpinner: boolean): void {
    this.dom.$deleteEntitiesButton.showSpinner = showSpinner;
    this.dom.$deleteEntitiesButton.disabled = showSpinner;
  }

  public showGuidedTour() {
    const currentView = this.dom.$smartViews.controller.getActiveView();
    const standardViewConfig = SmartViewsHelper.convertGenericConfigToGridConfig(currentView);

    // if not on General view
    if (!standardViewConfig.isDefault) {
      return;
    }

    const learnMoreText = translateFn('Learn more');
    const viewLaterText = translateFn('View later');

    const carouselData: CarouselInfoCardData[] = [
      {
        id: 'tour-card-introduction',
        pointerPosition: CarouselInfoCardPointerPosition.RIGHT_BORDER_UPPER_SIDE,
        bodyTitle: translateFn('Network'),
        description: [
          translateFn('Welcome to the new Network section!'),
          translateFn(
            'Take this guided tour to explore the new capabilities, learn more from the official documentation, or dismiss it if you are already familiar with the changes.'
          ),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: viewLaterText,
        secondaryButtonAction: this.guidedTourSecondaryButtonAction,
      },
      {
        id: 'tour-card-tree-view',
        pointerPosition: CarouselInfoCardPointerPosition.LEFT_BORDER_UPPER_SIDE,
        bodyTitle: translateFn('Tree view'),
        description: [
          translateFn('Easily view, navigate, and organize your network structure.'),
          translateFn('Create folders and manage them inline using the three-dot menu.'),
          translateFn('Quickly locate even deeply nested entities with the search box.'),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: viewLaterText,
        secondaryButtonAction: this.guidedTourSecondaryButtonAction,
      },
      {
        id: 'tour-card-smart-views',
        pointerPosition: CarouselInfoCardPointerPosition.LEFT_BORDER_UPPER_SIDE,
        bodyTitle: translateFn('Smart views'),
        description: [
          translateFn('Focus on specific entities in the grid with preconfigured filters and columns.'),
          translateFn(
            'Use default smart views or create your own by selecting and saving preferred filters and columns.'
          ),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: viewLaterText,
        secondaryButtonAction: this.guidedTourSecondaryButtonAction,
      },
      {
        id: 'tour-card-icons',
        pointerPosition: CarouselInfoCardPointerPosition.RIGHT_BORDER_UPPER_SIDE,
        bodyTitle: translateFn('Icons'),
        description: [
          translateFn('Identify entities with clear and consistent icons.'),
          translateFn('Find status and other details in dedicated columns.'),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: viewLaterText,
        secondaryButtonAction: this.guidedTourSecondaryButtonAction,
      },
      {
        id: 'tour-card-filters',
        pointerPosition: CarouselInfoCardPointerPosition.TOP_BORDER_RIGHT_SIDE,
        bodyTitle: 'Filters and columns ',
        description: [
          translateFn(
            'Refine your view with filters in a single, intuitive interface. They replace old status icons with clearer options like role and entity type.'
          ),
          translateFn('Filters enhance data consistency by aligning with columns wherever applicable.'),
          translateFn('In columns, quickly extract information using the Copy to clipboard option.'),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: viewLaterText,
        secondaryButtonAction: this.guidedTourSecondaryButtonAction,
      },
      {
        id: 'tour-card-mega-menu',
        pointerPosition: CarouselInfoCardPointerPosition.RIGHT_BORDER_UPPER_SIDE,
        bodyTitle: translateFn('Mega menu'),
        description: [
          translateFn('Use actions to manage devices, policies, integrations, and security incidents.'),
          translateFn('Actions are grouped by category for quick access.'),
        ],
        primaryButtonText: learnMoreText,
        primaryButtonAction: this.guidedTourPrimaryButtonAction,
        secondaryButtonText: translateFn('Exit tour'),
        secondaryButtonAction: () => {
          GuidedToursManager.exitGuidedTour(GuidedTourSections.NETWORK);
        },
      },
    ];

    GuidedToursManager.showTour({
      section: GuidedTourSections.NETWORK,
      step: Application.Main.user.additionalUserSettings?.guidedTours[GuidedTourSections.NETWORK].step || 0,
      pointerTargets: this.guidedTourTargetElements,
      highlightTargets: this.guidedTourHighlightElements,
      cards: carouselData,
      closeBtnTooltipText: translateFn('Close and do not show again'),
    });
  }

  private guidedTourPrimaryButtonAction(): void {
    const a = document.createElement('a');

    // Set the href and download attributes for the anchor element
    a.target = '_blank';
    a.href = Application.Main.company.isPartner()
      ? 'https://www.bitdefender.com/business/support/en/77211-155130-network-inventory.html '
      : 'https://www.bitdefender.com/business/support/en/77209-155130-network-inventory.html ';
    a.click();
  }

  private guidedTourSecondaryButtonAction(): void {
    GuidedToursManager.hideTourThisSession(GuidedTourSections.NETWORK);
    GuidedToursManager.getGuidedTourCarouselComponent(GuidedTourSections.NETWORK).remove();
  }

  public setGuidedTourTargetElementsOrder(): void {
    this.guidedTourTargetElements = [
      this.dom.$sectionTitle,
      this.treeTourTargetElement,
      this.smartViewsTourTargetElement,
      this.iconsTourTargetElement,
      this.filtersTourTargetElement,
      this.megaMenuTourTargetElement,
    ];
    this.guidedTourHighlightElements = [
      this.dom.$sectionTitle,
      this.treeHighlightTargetElement,
      this.smartViewsHighlightTargetElement,
      this.iconsHighlightTargetElement,
      this.filtersHighlightElement,
      this.megaMenuHighlightElement,
    ];
  }

  public setTreeTourTargetElement(): GuidedTourSetterResponse {
    let alreadyIncreasedCounter = false;

    if (this.treeTourTargetElement) {
      alreadyIncreasedCounter = true;
    }

    this.treeTourTargetElement = queryShadowHierarchy(this.shadow.querySelector('#network-tour-tree-accordion'), [
      'gz-icon.dropdown-icon',
    ]) as HTMLElement;

    this.treeHighlightTargetElement = queryShadowHierarchy(this.shadow.querySelector('gz-push-body-layout'), [
      '#pushBodySidenav',
    ]) as HTMLElement;

    return { alreadyIncreasedCounter: alreadyIncreasedCounter };
  }

  public setFiltersTourTargetElement(): GuidedTourSetterResponse {
    let alreadyIncreasedCounter = false;

    if (this.filtersTourTargetElement) {
      alreadyIncreasedCounter = true;
    }

    this.filtersTourTargetElement = queryShadowHierarchy(this.shadow.querySelector('gz-grid-view'), [
      'gz-grid-filters',
      'gz-enum-filter#moreFilters',
      'gz-dropdown-menu',
    ]) as HTMLElement;

    this.filtersHighlightElement = queryShadowHierarchy(this.shadow.querySelector('gz-grid-view'), [
      'gz-grid-filters',
    ]) as HTMLElement;

    return { alreadyIncreasedCounter: alreadyIncreasedCounter };
  }

  public setSmartViewsTourTargetElement(): GuidedTourSetterResponse {
    let alreadyIncreasedCounter = false;

    if (this.smartViewsTourTargetElement) {
      alreadyIncreasedCounter = true;
    }

    this.smartViewsTourTargetElement = queryShadowHierarchy(this.shadow.querySelector('gz-generic-grid-smart-views'), [
      'gz-generic-smart-views-list#genericSmartViewsList',
      'gz-input-search#views-input-search',
      '[part=input]',
    ]) as HTMLElement;

    this.smartViewsHighlightTargetElement = queryShadowHierarchy(this.shadow.querySelector('gz-push-body-layout'), [
      '#pushBodySidenav',
    ]) as HTMLElement;

    return { alreadyIncreasedCounter: alreadyIncreasedCounter };
  }

  public setIconsTourTargetElement(): GuidedTourSetterResponse {
    let alreadyIncreasedCounter = false;

    if (this.iconsTourTargetElement) {
      alreadyIncreasedCounter = true;
    }

    this.iconsTourTargetElement = (
      queryShadowHierarchy(this.shadow.querySelector('gz-grid-view'), ['vaadin-grid']) as HTMLElement
    ).querySelector('gz-icon') as HTMLElement;

    this.iconsHighlightTargetElement = Array.from(
      (
        queryShadowHierarchy(this.shadow.querySelector('gz-grid-view'), ['vaadin-grid']) as HTMLElement
      ).querySelectorAll('gz-icon')
    );

    return { alreadyIncreasedCounter: alreadyIncreasedCounter };
  }

  public setMegaMenuTourTargetElement() {
    let alreadyIncreasedCounter = false;

    if (this.megaMenuTourTargetElement) {
      alreadyIncreasedCounter = true;
    }

    this.megaMenuTourTargetElement = this.shadow.querySelector('gz-generic-overlay > gz-button');
    this.megaMenuHighlightElement = this.shadow.querySelector('gz-generic-overlay > gz-button');

    return { alreadyIncreasedCounter: alreadyIncreasedCounter };
  }

  private async injectSmartViewDependencies(): Promise<void> {
    this.smartViewsDependencies = await Application.lib.nirvana.dependenciesHelper.getDependenciesForGzApi(
      Application.lib.smartView.smartView.getGzSmartViewClients()
    );
    this.dom.$smartViews.injectDependencies({
      getUserCompany: () => {
        return {
          companyId: Application.Main.getUser().company.id,
          companyName: Application.Main.getUser().company.name,
        };
      },
      translateFn: nirvana.translator?.translateFn,
      componentName: this.smartViewsComponentName,
      ...this.smartViewsDependencies,
    });

    if (!this.dom.$smartViews.started) {
      await this.dom.$smartViews.start();
    } else {
      await this.dom.$smartViews.controller.render();
    }
  }

  private buildEarlyAccessSection(): void {
    this.dom.$feedbackFormButton.onclick = () => this.handleFeedBackBtnClicked();
  }

  private handleFeedBackBtnClicked(): void {
    NetworkPopUpFactory.getContent(NetworkPopUpType.NETWORK_FEEDBACK_FORM);
  }

  // This function overrides view props with external params and returns both the updated view and the initial view
  private processExternalParams(view: NetworkViewGridConfig, externalParams?: NetworkGridAppExternalParams) {
    const predefinedFilters: any = _.cloneDeep(view.filters).filter(filter =>
      this.gridData.predefinedFilterKeys.includes(Object.keys(filter)[0] as NetworkColumn)
    );
    let initialViewWithoutExternalParams;
    if (externalParams && Object.keys(externalParams).length > 0) {
      initialViewWithoutExternalParams = _.cloneDeep(view);

      // this algorithm is not enough because it does not remove filters, only adds those sent through externalParams.
      // we need to also support removing filters (through external params), so, for now, we will overwrite view.filters instead.
      // However, we need to keep the predefined filters, because the user can't just re-add them
      // see this: https://bitdefender.atlassian.net/browse/CERES-58673
      // the overwriting might also prove to be not enough when dealing with navigations in this section.

      if (externalParams.filters) {
        view.filters = externalParams.filters;
      }

      for (const predefinedFilter of predefinedFilters || []) {
        const filterName = Object.keys(predefinedFilter)[0];
        const filterIndex = view.filters.findIndex(elem => {
          return Object.keys(elem).includes(filterName);
        });
        if (filterIndex === -1) {
          view.filters.unshift(predefinedFilter);
        }
      }

      if (externalParams.treeDetails) {
        view.treeDetails = externalParams.treeDetails;
      }

      view.recursive = !!externalParams.recursive;

      if (externalParams.displayedColumns) {
        view.displayedColumns = externalParams.displayedColumns;
      }

      if (externalParams.selectedViewId) {
        view.id = externalParams.selectedViewId;
      }

      if (externalParams.columnConfigs) {
        view.columnConfigs = externalParams.columnConfigs;
      }

      // ideally we wouldn't touch initialViewWithoutExternalParams
      // *sometimes* external params comes with columnConfigs alphabetically sorted. The proper fix would be to find why
      // and when . For now, in order for our algorithm to work correctly, we will make sure both configs are sorted
      initialViewWithoutExternalParams.columnConfigs.sort((a: GridColumnConfiguration, b: GridColumnConfiguration) =>
        a.key.localeCompare(b.key)
      );
      view.columnConfigs.sort((a: GridColumnConfiguration, b: GridColumnConfiguration) => a.key.localeCompare(b.key));
    }

    return {
      view,
      initialViewWithoutExternalParams,
    };
  }

  private async buildSmartViews() {
    if (!(this.dom.$smartViews instanceof GenericGridSmartViewsWebComponent)) {
      throw new Error('Missing grid smart views');
    }

    this.dom.$smartViews.categoriesConfig = this.getSmartViewsCategories();
    this.dom.$smartViews.hasSearchInput = true;
    this.dom.$smartViews.emptySavedViewsText = translateFn('No views found!');
    this.dom.$smartViews.searchPlaceholderString = translateFn('Search in smart views');
    this.dom.$smartViews.isEditedFn = this.isCurrentViewEdited.bind(this);

    await this.injectSmartViewDependencies();

    this.dom.$smartViews.dispatchEvent(
      new CustomEvent(SmartViewEvents.SMART_VIEWS_RENDERED, {
        composed: true,
        bubbles: true,
      })
    );
  }

  public isCurrentViewEdited() {
    return this.dom.$grid.isViewChanged();
  }

  private getSmartViewsCategories(): CategoriesConfig {
    // TODO @aoprea Add translated view names CERES-50655
    const defaultTranslations = {};
    const handler = {
      get: function (target, prop) {
        return prop;
      },
    };
    const translationProxy = new Proxy(defaultTranslations, handler);

    return {
      internalCategories: {
        recent: {
          isAvailable: false,
          translations: {},
        },
        favorites: {
          isAvailable: true,
          translations: {},
          isOpen: true,
        },
        default: {
          isAvailable: true,
          translations: translationProxy,
          sectionTitle: translateFn('Management'),
          isOpen: true,
        },
      },
      customCategories: [
        {
          sectionTitle: this.dependencies.translateFn('Saved'),
          emptyStateItemText: this.dependencies.translateFn('No saved views yet'),
          type: NETWORK_VIEW_CATEGORIES_TYPES.SAVED,
          inlineActions: [
            {
              title: this.dependencies.translateFn('Rename'),
              value: SmartViewInlineActions.RENAME,
            },
            {
              title: this.dependencies.translateFn('Delete'),
              value: SmartViewInlineActions.DELETE,
              customClass: 'danger',
            },
          ],
          isOpen: true,
          smartViewMaxInputLength: SMART_VIEW_MAX_INPUT_LENGTH,
          noSpaceEscape: true,
          smartViewValidators: [
            RequiredValidator('This field is required.'),
            RemoteValidator(
              (value: string) => {
                const viewName = value.trimEnd().trimStart();

                return this.smartViewsDependencies.api.clients.SmartViews.validateViewName(
                  this.smartViewsComponentName,
                  {
                    name: viewName,
                    checkUniqueness: true,
                  }
                );
              },
              (response: ValidateViewNameResponse) => response.valid,
              (response: ValidateViewNameResponse) => this.translateValidateViewNameErrorCode(response.errorCode),
              this.dependencies.translateFn('A communication error has occurred. Please try again later.')
            ),
          ],
          items: [],
        },
        {
          sectionTitle: this.dependencies.translateFn('Security issues'),
          type: NETWORK_VIEW_CATEGORIES_TYPES.SECURITY_ISSUES,
          inlineActions: [],
          isOpen: false,
          smartViewMaxInputLength: SMART_VIEW_MAX_INPUT_LENGTH,
          noSpaceEscape: true,
          smartViewValidators: [],
          items: [],
        },
        {
          sectionTitle: this.dependencies.translateFn('Pending activity'),
          type: NETWORK_VIEW_CATEGORIES_TYPES.PENDING_ACTIVITY,
          inlineActions: [],
          isOpen: false,
          smartViewMaxInputLength: SMART_VIEW_MAX_INPUT_LENGTH,
          noSpaceEscape: true,
          smartViewValidators: [],
          items: [],
        },
        {
          sectionTitle: this.dependencies.translateFn('Policies'),
          type: NETWORK_VIEW_CATEGORIES_TYPES.POLICIES,
          inlineActions: [],
          isOpen: false,
          smartViewMaxInputLength: SMART_VIEW_MAX_INPUT_LENGTH,
          noSpaceEscape: true,
          smartViewValidators: [],
          items: [],
        },
      ],
    };
  }

  private buildErrorTemplate(): void {
    const errorTemplate = new GzImageRepoWebComponent();
    errorTemplate.state = ImageState.ERROR;
    errorTemplate.innerHTML = `
            <gz-title fontWeight="500" fontSize="20" class="error-text title">${this.dependencies.translateFn(
              'A general system error occurred.'
            )}</gz-title>
            <gz-text fontSize="13" class="error-text subtitle">${this.dependencies.translateFn(
              'Please contact Bitdefender Enterprise Support for more information.'
            )}</gz-text>
    `;

    this.dom.$wrapper.appendChild(errorTemplate);
  }

  private buildGridGlobalActionsToolbar(): void {
    this.configureActionsButton();
    this.configureDeleteEntitiesButton();
    this.buildReportsButton();
  }

  private buildReportsButton() {
    this.dom.$reportsButton.textContent = this.buttonStrings.reports;
  }

  private configureActionsButton() {
    this.dom.$globalActionsButton.innerHTML = `<span class="button-text">${this.dependencies.translateFn(
      'Actions'
    )}</span> <span class="icon ds-icon-dropdown_arrow"></span>`;
    this.configureMegaMenu();

    this.dom.$goToContainerButton.innerHTML = `<span class="button-text">${this.buttonStrings.goTo}</span>`;

    if (Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_VOLUME_ENCRYPTION_VISIBLE])) {
      this.dom.$recoveryManagerButton.textContent = translateFn('Recovery manager');
      toggleVisibility(this.dom.$recoveryManagerButton, true);
    }
  }

  private configureMegaMenu() {
    this.dom.$megaMenu.noResultsMessage = this.dependencies.translateFn('No results found');
    this.dom.$megaMenu.quickActionsString = this.dependencies.translateFn('Quick actions');
    this.dom.$megaMenu.iconMap = MegaMenuHelper.getMegaMenuIconMap() as MegaMenuIconMap;

    const event = new CustomEvent(MegaMenuEvents.COMPUTE_MEGA_MENU_SECTIONS, {});
    this.dom.$megaMenu.dispatchEvent(event);
  }

  private translateValidateViewNameErrorCode(errorCode: number) {
    if (errorCode === ValidateViewNameErrorCodeResponse.INVALID_VIEWNAME_LENGTH_CODE) {
      return this.dependencies.translateFn('A view name must have a maximum of 64 characters.');
    }
    if (errorCode === ValidateViewNameErrorCodeResponse.INVALID_VIEWNAME_DUPLICATE_NAME_CODE) {
      return this.dependencies.translateFn('A view with this name already exists.');
    }
    if (errorCode === ValidateViewNameErrorCodeResponse.INVALID_VIEWNAME_INVALID_CHARACTERS) {
      return this.dependencies.translateFn('A view name must not contain special characters.');
    }
  }

  private setGlobalActionsButtons(): void {
    this.dom.$globalActionsOverlay = this.shadow.querySelector(`${WEB_COMPONENT_GZ_GENERIC_OVERLAY}#actions-overlay`);
    this.dom.$globalActionsButton = this.shadow.querySelector(`${WEB_COMPONENT_GZ_BUTTON}#global-actions-button`);
    this.dom.$megaMenu = this.shadow.querySelector(
      `${WEB_COMPONENT_GZ_MEGA_MENU}#actions-mega-menu`
    ) as GzMegaMenuWebComponent;

    this.dom.$deleteEntitiesButton = this.shadow.querySelector(
      `${WEB_COMPONENT_GZ_BUTTON}#delete-entities`
    ) as GzButtonWebComponent;
    this.dom.$reportsButton = this.shadow.querySelector(`${WEB_COMPONENT_GZ_BUTTON}#reports-button`);
    this.dom.$recoveryManagerButton = this.shadow.querySelector(`${WEB_COMPONENT_GZ_BUTTON}#recovery-manager-button`);
  }

  private configureDeleteEntitiesButton(): void {
    this.dom.$deleteEntitiesButton.innerHTML = this.buttonStrings.delete;
    this.dom.$deleteEntitiesButton.type = ButtonTypes.OUTLINE;
    this.dom.$deleteEntitiesButton.color = ButtonColors.NEGATIVE;
  }

  public handleRowRightClicked(coords: Coords, selectedItems: Array<any>): void {
    this.dom.$overlayList.listItems = selectedItems;
    this.dom.$overlay.openOverlay(coords);
  }

  private configureJumpToContainer(): void {
    const topTargetSelector = {
      selector: 'network-panel-content',
      label: translateFn('Network tree'),
    };
    const bottomTargetSelector = {
      selector: 'network-smart-views',
      label: translateFn('Smart views'),
    };

    this.dom.$networkScrollableWrapper.topTargetSelector = topTargetSelector;
    this.dom.$networkScrollableWrapper.bottomTargetSelector = bottomTargetSelector;
  }

  protected onDisconnect() {
    this.gridErrorSubscription$.unsubscribe();
  }
}
